import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Tag } from "antd";
import { ReactElement, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import logoKkb from "../../assets/logoKkb.svg";
import { ApplicationTabs } from "../../components/Application/ApplicationDetails/ApplicationTabs/ApplicationTabs";
import { useGetApplicationDataQuery } from "../../store/api/application.api";
import { useSendDataToSigningMutation } from "../../store/api/applicationBankApi/applicationBank.api";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import { SELECT_APPLICATION_AGENT } from "../../store/selectors/requestAppSelector";
import { CLEAR_APPLICATION_DATA_TO_BANK } from "../../store/slice/applicationDataToBankSlice/applicationDataToBankSlice";
import { USER } from "../../types/indexTypeEnum";
import { UI_ITOModuleTitle } from "../../UI_ITO/indexUI";
import { Guard } from "../../utils/guards/Guard";

import classes from "./PageApplicationAdditional.module.css";

/**
 * Компонент страницы допзаявки КамКомБанка.
 */
export function PageApplicationAdditional(): ReactElement {
  const { applicationId, applicationBankId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const agent = useAppSelector(SELECT_APPLICATION_AGENT);

  // Данные основной заявки
  const { data: applicationMain } = useGetApplicationDataQuery(
    Number(applicationId),
  );

  // Данные статуса заявки после отправки на подписание
  const [, { data: statusInfoAfterSigning }] = useSendDataToSigningMutation({
    fixedCacheKey: `SHARED_SIGNING_RESULT_${applicationId}`,
  });

  const agentName = `${applicationMain?.data.agent.surname ?? ""} ${
    applicationMain?.data.agent.name ?? ""
  }  ${applicationMain?.data.agent.patronymic ?? ""}`;

  // После отправки на подписание меняется статус заявки
  const statusTitle = statusInfoAfterSigning
    ? statusInfoAfterSigning.message.title
    : applicationMain?.data?.status.title;

  const statusColor = statusInfoAfterSigning
    ? statusInfoAfterSigning.message.color
    : applicationMain?.data?.status.color;

  useEffect(() => {
    return () => {
      dispatch(CLEAR_APPLICATION_DATA_TO_BANK());
    };
  }, [dispatch]);

  function closeApplicationAdditional() {
    return navigate(-1);
  }

  return (
    <div className={classes.additionalApplication}>
      <ApplicationTabs>
        <div className={classes.additionalApplication__container}>
          <div className={classes.additionalApplication__header}>
            <Button
              type="text"
              onClick={closeApplicationAdditional}
              className={classes.additionalApplication__backButton}
            >
              <ArrowLeftOutlined />
              Вернуться к заявке
            </Button>
            <div className={classes.additionalApplication__logo}>
              <img src={logoKkb} alt="Логотип Камкомбанка" />
            </div>
          </div>

          <div className={classes.additionalApplication__title}>
            <UI_ITOModuleTitle title={`Заявка № ${applicationBankId ?? 0}`} />
            <Tag color={statusColor}>{statusTitle}</Tag>
          </div>
          <Guard.Role roles={[USER.SUPPORT_CREDIT, USER.SUPPORT_ADMIN]}>
            <div className={classes.additionalApplication__subtitle}>
              {"Заявитель: "}
              <Link
                to={`/list-agent/${agent?.id}`}
                onClick={(event) => event.stopPropagation()}
                style={{}}
                className={classes.additionalApplication__link}
              >
                {agentName}
              </Link>
            </div>
          </Guard.Role>
        </div>
      </ApplicationTabs>
    </div>
  );
}
